module.exports = __webpack_public_path__ + "eccc2baefc4f659c37c0441b342b7e11.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/WW-EUR.svg
// module id = Jc8+
// module chunks = 0